export default __webpack_public_path__ + "static/media/phalcon.37c48859.svg";